import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { EmptyState } from '@ntconsult/aluma-react';

export function VideoTranscriptionTab() {
  const { t } = useTranslation('video');

  return (
    <EmptyState
      decorator={<FileText className="w-6 h-6 text-foreground-subtle" aria-hidden="true" />}
      decoratorPlacement="start"
      align="start"
      title={t('transcription.comingSoon')}
      description={t('transcription.description')}
      size="sm"
    />
  );
}
